export const ROUTE_PATH = '/valet-parking';

export const FEATURE_NAME = 'valetParkingPage';
